import ButtonReset from './ButtonReset';
export default ButtonReset;
